import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "bootstrap-daterangepicker/daterangepicker.css";
import { getLeads, deleteLead, addLead, updateLead, getLeadDetail, updateLeadStatus, importLeadFromCSVFile, exportLead, assignTagToLead, getAllContactsConvert, getOpportunitiesConvert, getAllCampaign, addToCampaign } from "./api";
import {
  countryoptions1,
  currency,
  languageOptions,
  optiondeals,
  optionindustry,
  options,
  options1,
  optionschoose,
  optionsource,
  optionSalutation,
  ratingOptions
} from "../../../core/common/selectoption/selectoption";

import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage } from "../../../core/common/selectWithImage";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { all_routes } from "../../router/all_routes";
import { getTypePipeline } from "../pipeline/pipelineAPI";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getLeadsKanban, convertLead } from "./api";
import { getTagList } from "../tags/tagAPI";
import ResponseModal from "../../../core/modals/response_modal";
import { listLeadsOption, listOpportunitiesOption, listContactsOptionn, listAccountsOption, userList } from "./logcall_api";
import { Modal, Form, Button } from "react-bootstrap";
import { getAllCompanies } from "../companies/companyAPI";
interface LeadKanban {
  stageId: number;
  stageName: string;
  noOfLead: number;
  leadKanbanDetails: {
    leadId: number;
    leadUuid: string;
    leadName: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    rating: string;
    companyName: string;
    leadOwner: string;
  }[];
}
interface Opportunity {
  id: number;
  name: string;
  type?: "new" | "existing";
}
interface Contact {
  contactId: number;
  contactName: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  type?: "new" | "existing";
}

interface User {
  id: number;
  username: string;
  uuid: string;
  role: string;
}
interface Account {
  accountId: number;
  accountName: string;
  type?: "new" | "existing";
}


interface Stage {
  id: number;
  name: string;
  order: number;
}
interface Lead {
  id: number;
  salutation: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  mobile?: string;
  rating?: number;
  owner?: string;
  title?: string;
  leadSource?: string;
  leadStatusId?: number;
  leadStatus?: string;
  language?: string;
  description?: string;
  company?: string;
  industry?: string;
  website?: string;
  noOfEmployees?: number;
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  facebook?: string;
  skype?: string;
  linkedin?: string;
  twitter?: string;
  instagram?: string;
  whatsapp?: string;
  memberId: number;
  selectedPeople: number[];
  tags: Array<{
    tagId: number;
    name: string;
  }>;
  statusDto: {
    statusId: number;
    existedAccountId: number | null;
    existedContactId: number | null;
    existedOpportunityId: number | null;
    createContactRequestDTO: {
      salutation: string;
      firstName: string;
      lastName: string;
    };
    opportunityName: string;
    accountName: string;
    createOpportunity: boolean;
  };

  campaignHistory?: Array<{
    campaignId: string;
    campaignName: string;
    startDate: string;
    endDate: string;
    type: string;
    status: string;
  }>;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  public: boolean;
}
interface LeadConvert {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company?: string;
  phone: string;
  email: string;
  leadStageId?: number;
  leadStatus?: string;
  createdDate: string;
  leadOwner?: string;
  stageId: number;
}

const LeadsKanban = () => {
  const [show, setShow] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [show3, setShow3] = useState(false);
  const [editingLead, setEditingLead] = useState<Lead | null>(null);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [visibility, setVisibility] = useState("public");
  const [accountType, setAccountType] = useState<"new" | "existing">("existing");
  const [contactType, setContactType] = useState<"new" | "existing">("existing");
  const [editedLeadUuid, setEditedLeadUuid] = useState(null);
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<number | "">("");
  const handleEditClick = async (leadUuid: string) => {
    console.log("Lead UUID:", leadUuid);
    try {
      const response = await getLeadDetail(leadUuid);
      console.log("lead UUID:", response.data.data.uuid);

      if (response.status === 200) {
        setEditingLead(response.data.data);
        setEditedLeadUuid(response.data.data.uuid);
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
    }
  };
  useEffect(() => {
    if (editingLead) {
      console.log("Editing Lead:", editingLead);
      console.log("Status ID:", editingLead?.statusDto?.statusId, "Lead Stage ID:", editingLead?.leadStatusId);
      setSelectedStatus(editingLead?.statusDto?.statusId ?? editingLead?.leadStatusId ?? "");
    }
  }, [editingLead]);
  const [opportunityType, setOpportunityType] = useState<"new" | "existing">("existing");
  const [newLead, setNewLead] = useState({
    id: 0,
    salutation: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    mobile: "",
    rating: 0,
    owner: "",
    title: "",
    leadSource: "",
    leadStatus: "",
    leadStatusId: 0,
    language: "",
    description: "",
    company: "",
    industry: "",
    website: "",
    noOfEmployees: 0,
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    facebook: "",
    skype: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    whatsapp: "",
    memberId: 0,
    selectedPeople: [] as number[],
    tags: [] as { tagId?: number; name: string }[],
    statusDto: {
      statusId: 0,
      existedAccountId: null as number | null,
      existedContactId: null as number | null,
      existedOpportunityId: null as number | null,
      createContactRequestDTO: {
        salutation: "",
        firstName: "",
        lastName: "",
      },
      opportunityName: "",
      accountName: "",
      createOpportunity: false,
    },
    public: true,
  });
  const handleClose = () => {
    setShow(false);
    setNewLead({
      id: 0,
      salutation: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      mobile: "",
      rating: 0,
      owner: "",
      title: "",
      leadSource: "",
      leadStatus: "",
      leadStatusId: 0,
      language: "",
      description: "",
      company: "",
      industry: "",
      website: "",
      noOfEmployees: 0,
      street: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      facebook: "",
      skype: "",
      linkedin: "",
      twitter: "",
      instagram: "",
      whatsapp: "",
      memberId: 0,
      selectedPeople: [],
      tags: [],
      statusDto: {
        statusId: 0,
        existedAccountId: null,
        existedContactId: null,
        existedOpportunityId: null,
        createContactRequestDTO: {
          salutation: "",
          firstName: "",
          lastName: "",
        },
        opportunityName: "",
        accountName: "",
        createOpportunity: false,
      },
      public: true,
    });
  };

  const handleClose3 = () => {
    setShow3(false);
  };

  const handleShow2 = () => {
    setNewLead({
      id: 0,
      salutation: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      mobile: "",
      rating: 0,
      owner: "",
      title: "",
      leadSource: "",
      leadStatus: "",
      leadStatusId: 0,
      language: "",
      description: "",
      company: "",
      industry: "",
      website: "",
      noOfEmployees: 0,
      street: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      facebook: "",
      skype: "",
      linkedin: "",
      twitter: "",
      instagram: "",
      whatsapp: "",
      memberId: 0,
      selectedPeople: [],
      tags: [],
      statusDto: {
        statusId: 0,
        existedAccountId: null,
        existedContactId: null,
        existedOpportunityId: null,
        createContactRequestDTO: {
          salutation: "",
          firstName: "",
          lastName: "",
        },
        opportunityName: "",
        accountName: "",
        createOpportunity: false,
      },
      public: true,
    });

    setShow(true);
  };

  const handleShow3 = () => setShow3(true);
  const [adduser, setAdduser] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<{ value: string; label: string } | null>(null);
  const [selectedContact, setSelectedContact] = useState<{ value: string; label: string } | null>(null);
  const [selectedOwners, setSelectedOwners] = useState<OptionType[]>([]);
  const [selectedOpportunity, setSelectedOpportunity] = useState<{ value: string; label: string } | null>(null);
  const [accountName, setAccountName] = useState("");
  const [addcompany, setAddCompany] = useState(false);
  const [ownerOptions, setOwnerOptions] = useState<{ value: string; label: string }[]>([]);
  const [createdLeadUuid, setCreatedLeadUuid] = useState(null);
  const [selectedSalutation, setSelectedSalutation] = useState<string | null>(null);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  const [tempSelectedUsers, setTempSelectedUsers] = useState<number[]>([]);
  const [showConvertModal, setShowConvertModal] = useState(false);
  const [selectedLeadForConvert, setSelectedLeadForConvert] = useState<{
    leadId: number;
    leadUuid: string;
    leadName: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    rating: string;
    companyName: string;
    leadOwner: string;
  } | null>(null);
  const [convertToContact, setConvertToContact] = useState(false);
  const [convertToOpportunity, setConvertToOpportunity] = useState(false);
  const [contactName, setContactName] = useState("");
  const [opportunityName, setOpportunityName] = useState("");
  const [contactOptions, setContactOptions] = useState<{ value: string; label: string }[]>([]);
  const [opportunityOptions, setOpportunityOptions] = useState<{ value: string; label: string }[]>([]);
  type OptionType = { value: string; label: string };
  const fetchContacts = async (accountId: number | null) => {
    if (!accountId) {
      setContactOptions([]);
      return;
    }

    try {
      const response = await getAllContactsConvert(accountId);
      const contacts = response.data.data.map((contact: Contact) => ({
        value: contact.contactId,
        label: contact.contactName,
      }));
      setContactOptions(contacts);
    } catch (error) {
      console.error("Error fetching Contacts:", error);
    }
  };
  const fetchOwners = async () => {
    try {
      const response = await listLeadsOption();
      const owners = response.data.data.map((lead: LeadConvert) => ({
        value: lead.leadUuid,
        label: lead.leadName,
      }));
      setOwnerOptions(owners);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };

  useEffect(() => {
    fetchAccounts();
    fetchOwners();
  }, []);
  const handleCloseConvertModal = () => {
    setShowConvertModal(false);
    setSelectedAccount(null);
    setSelectedContact(null);
    setSelectedOpportunity(null);
    fetchLeadKanban();
  };
  const [leadKanban, setLeadKanban] = useState<LeadKanban[]>([]);
  const fetchLeadKanban = async () => {
    try {
      const response = await getLeadsKanban();
      console.log("API Response:", response.data);
      if (response.data && response.data.data) {
        const leads = response.data.data.map((lead: LeadKanban) => ({
          stageId: lead.stageId,
          stageName: lead.stageName,
          noOfLead: lead.noOfLead,
          leadKanbanDetails: lead.leadKanbanDetails
        }));
        setLeadKanban(leads);
      } else {
        console.error("Invalid API response:", response.data);
        setLeadKanban([]);
      }
    } catch (error) {
      console.error("Error fetching pricebook list:", error);
      setLeadKanban([]);
    }
  }
  useEffect(() => {
    fetchLeadKanban();
  }, []);
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const [statusOptions, setStatusOptions] = useState<Stage[]>([]);
  const [accountOptions, setAccountOptions] = useState<{ value: string; label: string }[]>([]);
  const [maxorder, setMaxorder] = useState<number | null>(null);

  const fetchAccounts = async () => {
    try {
      const response = await getAllCompanies();
      const acc = response.data.data.map((acc: Account) => ({
        value: acc.accountId,
        label: acc.accountName,
      }));
      setAccountOptions(acc);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };
  useEffect(() => {
    const fetchStatusEditOptions = async () => {
      try {
        const response = await getTypePipeline("LEAD");
        const data = response.data.data || [];
        console.log("Pipeline data:", data);
        setStatusOptions(data);

        const validorders = data.map((item: Stage) => item.id).filter((id: number) => id !== undefined && id !== null);
        const maxOrder = validorders.length > 0 ? Math.max(...validorders) : 0;

        console.log("Max order:", maxOrder);
        setMaxorder(maxOrder);

      } catch (error) {
        console.error("Error fetching status options:", error);
      }
    };

    fetchStatusEditOptions();
  }, []);
  const [addStatusOptions, setAddStatusOptions] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    const fetchStatusOptions = async () => {
      try {
        const response = await getTypePipeline("LEAD");
        if (response?.data) {
          console.log("Status option:", response.data.data);
          const options = response.data.data.map((stage: Stage) => ({
            value: stage.id,
            label: stage.name
          }));
          setAddStatusOptions(options);
        }
      } catch (error) {
        console.error("Error fetching status options:", error);
      }
    };

    fetchStatusOptions();
  }, []);
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    const userTenantId = Number(localStorage.getItem("userTenantId"));
    userList(userTenantId).then(response => setUsers(response.data.data));
  }, []);
  const handleCreateLead = async () => {
    if (!newLead) {
      console.error("Error: No valid lead data!", newLead);
      return;
    }

    const selectedStatus = statusOptions.find(
      (status: Stage) => status.id === newLead.statusDto.statusId
    );

    console.log("Selected Status:", selectedStatus);
    console.log("Max order from state:", maxorder);

    if (selectedStatus?.order === maxorder) {
      console.log("Opening Convert Modal...");
      setShowConvertModal(true);
    } else {
      console.log("Creating lead...");
      await createLeadData();
    }
  };
  const createLeadData = async () => {
    try {
      console.log("Creating Lead...");
      const response = await addLead(newLead);

      if (response.status === 200) {
        console.log("Lead created successfully");
        const createdLead = response.data.data;
        setCreatedLeadUuid(createdLead.uuid);
        setOpenModal(true);
      }
    } catch (error) {
      console.error("Error creating lead:", error);
    }
  };
  const fetchOpportunities = async (accountId: number | null) => {
    if (!accountId) {
      setOpportunityOptions([]);
      return;
    }

    try {
      const response = await getOpportunitiesConvert(accountId);
      console.log("res:", response.data.data)
      const opportunities = response.data.data.map((oppor: Opportunity) => ({
        value: oppor.id,
        label: oppor.name,
      }));
      setOpportunityOptions(opportunities);
    } catch (error) {
      console.error("Error fetching Opportunities:", error);
    }
  };
  useEffect(() => {
    if (selectedAccount?.value && selectedAccount.value !== "new") {
      const accountId = Number(selectedAccount.value);
      fetchContacts(accountId);
      fetchOpportunities(accountId);
      setSelectedContact(null);
      setSelectedOpportunity(null);
    } else {
      setContactOptions([]);
      setOpportunityOptions([]);
      setSelectedContact(null);
      setSelectedOpportunity(null);
    }
  }, [selectedAccount]);
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  const handleSelectChange = (
    selectedOption: { value: string; label: string } | null,
    field: string
  ) => {
    setNewLead((prevState) => {
      if (!prevState) return prevState;

      return {
        ...prevState,
        [field]: selectedOption ? selectedOption.value : ""
      };
    });
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    console.log("Value: " + name + " " + value);

    setNewLead(prevState => {
      console.log("State value: " + JSON.stringify(prevState));
      return ({
        ...prevState,
        [name]: value
      })
    });
  };
  const togglePopup = (isEditing: any) => {
    setModalTitle(isEditing ? "Edit Lead" : "Add New Lead");
    setAdduser(!adduser);
  };
  const addcompanyPopup = () => {
    setAddCompany(!addcompany);
  };
  const route = all_routes;

  const handleDragEnd = async (result: any) => {
    if (!result.destination) return;

    const { source, destination } = result;
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return;
    }

    const sourceStage = leadKanban.find(stage => stage.stageId.toString() === source.droppableId);
    const destStage = leadKanban.find(stage => stage.stageId.toString() === destination.droppableId);
    if (!sourceStage || !destStage) return;

    const [movedLead] = sourceStage.leadKanbanDetails.splice(source.index, 1);
    destStage.leadKanbanDetails.splice(destination.index, 0, movedLead);
    setLeadKanban([...leadKanban]);

    try {
      if (destStage.stageId !== maxorder) {
        const requestData = {
          statusId: parseInt(destination.droppableId),
          existedAccountId: null,
          existedContactId: null,
          existedOpportunityId: null,
          createContactRequestDTO: {
            salutation: null,
            firstName: null,
            lastName: null,
          }
        };

        const response = await updateLeadStatus(movedLead.leadId, requestData);
        if (response.status === 200) {
          fetchLeadKanban();
          setResponse({
            status: "success",
            message: "Updated lead status successfully!"
          });
        } else {
          throw new Error("API returned non-200");
        }
        setShowMessageModal(true);
      } else {
        setSelectedLeadForConvert(movedLead);
        handleEditClick(movedLead.leadUuid);
        setAccountType("existing");
        setContactType("existing");
        setOpportunityType("existing");
        setShowConvertModal(true);
      }
    } catch (error) {
      console.error("Error updating lead status:", error);
      setResponse({
        status: "error",
        message: "Failed to update lead status!"
      });

      // Revert UI
      sourceStage.leadKanbanDetails.splice(source.index, 0, movedLead);
      destStage.leadKanbanDetails.splice(destination.index, 1);
      setLeadKanban([...leadKanban]);
      setShowMessageModal(true);
    }
  };


  const handleConvertLead = async () => {
    if (!editingLead?.id) {
      console.error("Error: No valid Lead ID found!", editingLead?.id);
      return;
    }

    try {
      const finalAccountName = accountType === "new" ? accountName || null : null;
      const finalOpportunityName = opportunityType === "new" ? opportunityName || null : null;

      const finalContactData =
        contactType === "new"
          ? {
            salutation: selectedSalutation || "",
            firstName: contactFirstName || "",
            lastName: contactLastName || "",
          }
          :
          {
            salutation: null,
            firstName: null,
            lastName: null,
          }
      const data = {
        statusId: maxorder,
        existedAccountId: accountType === "existing" ? Number(selectedAccount?.value) || null : null,
        existedContactId: contactType === "existing" ? Number(selectedContact?.value) || null : null,
        existedOpportunityId: opportunityType === "existing" ? Number(selectedOpportunity?.value) || null : null,
        createContactRequestDTO: finalContactData,
        opportunityName: finalOpportunityName,
        accountName: finalAccountName,
        createOpportunity: opportunityType === "new",
      };

      console.log("Dữ liệu gửi lên API:", data);

      const response = await updateLeadStatus(editingLead?.id, data);

      if (response?.status === 200) {
        setResponse({ status: "success", message: "Lead converted successfully!" });
        setShowConvertModal(false);
      } else {
        console.error("API Error:", response);
        setResponse({ status: "error", message: "Failed to convert lead. Please try again!" });
      }
    } catch (error) {
      console.error("Error converting lead:", error);
      setResponse({ status: "error", message: "An unexpected error occurred. Please check the console for details." });
    } finally {
      setShowMessageModal(true);
    }
  };

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Leads<span className="count-title">{leadKanban.length}</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                {/* Filter */}
                <div className="d-flex justify-content-between align-items-center flex-wrap row-gap-2 mb-4">
                  <div>
                    <ul className="d-flex align-items-center">
                      <li>
                        <div className="view-icons me-2">
                          <Link to={route.leads}>
                            <i className="ti ti-list-tree" />
                          </Link>
                          <Link to={route.leadsKanban} className="active">
                            <i className="ti ti-grid-dots" />
                          </Link>
                        </div>
                      </li>
                      <li>
                        <Link to="#" className="btn btn-primary ms-2" onClick={handleShow2}>
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Leads
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* /Filter */}
                {/* Leads Kanban */}
                <DragDropContext onDragEnd={handleDragEnd}>
                  <div className="d-flex overflow-x-auto align-items-start mb-4">
                    {leadKanban.map((stage) => (
                      <Droppable key={stage.stageId} droppableId={stage.stageId.toString()}>
                        {(provided) => (
                          <div
                            className="kanban-list-items"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            <div className="card mb-0">
                              <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <h4 className="fw-semibold d-flex align-items-center mb-1">
                                      <i className="ti ti-circle-filled fs-8 text-warning me-2" />
                                      {stage.stageName}
                                    </h4>
                                    <span className="fw-medium text-default">
                                      {stage.noOfLead} Leads
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <Link to="#" className="text-purple" onClick={handleShow2}>
                                      <i className="ti ti-plus" />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="kanban-drag-wrap pt-4">
                              {stage.leadKanbanDetails.map((lead, index) => (
                                <Draggable
                                  key={lead.leadId}
                                  draggableId={lead.leadId.toString()}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className="card kanban-card border">
                                        <div className="card-body">
                                          <div className="d-block">
                                            <div className="bg-warning border border-2 mb-3" />
                                            <div className="d-flex align-items-center mb-3">
                                              <h6 className="fw-medium">
                                                <Link to={`/leads-details/${lead.leadUuid}`}>
                                                  {lead.leadName}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                          <div className="mb-3 d-flex flex-column">
                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                              <i className="ti ti-mail text-dark me-1" />
                                              {lead.email}
                                            </p>
                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                              <i className="ti ti-phone text-dark me-1" />
                                              {lead.phone}
                                            </p>
                                            <p className="text-default d-inline-flex align-items-center">
                                              <i className="ti ti-map-pin-pin text-dark me-1" />
                                              {lead.city}, {lead.country}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          </div>
                        )}
                      </Droppable>
                    ))}
                  </div>
                </DragDropContext>
                <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
                {/* /Leads Kanban */}
              </div>
            </div>
          </div>
        </div>

        {/* /Page Wrapper */}
        <div
          className="modal custom-modal fade"
          id="delete_contact"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0 m-0 justify-content-end">
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="success-message text-center">
                  <div className="success-popup-icon">
                    <i className="ti ti-trash-x" />
                  </div>
                  <h3>Remove Leads?</h3>
                  <p className="del-info">
                    Are you sure you want to remove lead you selected.
                  </p>
                  <div className="col-lg-12 text-center modal-btn">
                    <Link
                      to="#"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="leads" className="btn btn-danger">
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Offcanvas show={show} onHide={handleClose} placement="end" >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Add New Lead</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="accordion" id="main_accordion">
                {/* Basic Info */}
                <div className="accordion-item rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#basic"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                      </span>
                      Basic Info
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse show"
                    id="basic"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Salutation</label>
                            <Select
                              className="select2"
                              options={optionSalutation}
                              classNamePrefix="react-select"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "salutation")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              First Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="firstName"
                              value={newLead.firstName}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Last Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="lastName"
                              value={newLead.lastName}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Company Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="company"
                              value={newLead.company}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center">
                              <label className="col-form-label">
                                Email <span className="text-danger">*</span>
                              </label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              value={newLead.email}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Phone <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              value={newLead.phone}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Mobile</label>
                            <input
                              type="text"
                              className="form-control"
                              name="mobile"
                              value={newLead.mobile}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Website <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="website"
                              value={newLead.website}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Ratings</label>
                            <div className="icon-form-end">
                              <span className="form-icon">
                                <i className="ti ti-star" />
                              </span>
                              <Select
                                className="select2"
                                options={ratingOptions}
                                classNamePrefix="react-select"
                                onChange={(selectedOption) =>
                                  handleSelectChange(selectedOption, "rating")
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Owner</label>
                            <Select
                              className="select2"
                              options={ownerOptions}
                              classNamePrefix="react-select"
                              value={selectedOwners ? selectedOwners[0] : null}
                              onChange={(selectedOption) => setSelectedOwners(selectedOption ? [selectedOption] : [])}
                              placeholder="Select Owner"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Status</label>
                            <Select
                              className="select2"
                              options={addStatusOptions}
                              classNamePrefix="react-select"
                              value={addStatusOptions.find(option => option.value === newLead.statusDto.statusId) || null}
                              onChange={(selectedOption) => {
                                console.log("Selected Status:", selectedOption);
                                setNewLead((prevLead) => ({
                                  ...prevLead,
                                  statusDto: {
                                    ...prevLead.statusDto,
                                    statusId: selectedOption?.value ?? 0,
                                  },
                                }));
                              }}
                            />

                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Tags <span className="text-danger">*</span>
                            </label>
                            <Select
                              isMulti
                              options={allTags.map(tag => ({
                                value: tag.id,
                                label: tag.name
                              }))}
                              placeholder="Select tags"
                              classNamePrefix="react-select"
                              value={newLead.tags.map(tag => ({
                                value: tag.tagId,
                                label: tag.name
                              }))}
                              onChange={(selectedOptions) => {
                                console.log("Selected Tags:", selectedOptions);
                                setNewLead(prev => ({
                                  ...prev,
                                  tags: selectedOptions ? selectedOptions.map(option => ({
                                    tagId: option.value,
                                    name: option.label
                                  })) : []
                                }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              value={newLead.title}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Source</label>
                            <Select
                              className="select2"
                              options={optionsource}
                              classNamePrefix="react-select"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "leadSource")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Industry</label>
                            <Select
                              className="select2"
                              options={optionindustry}
                              classNamePrefix="react-select"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "industry")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">No. of Employees</label>
                            <input
                              type="text"
                              className="form-control"
                              name="noOfEmployees"
                              value={newLead.noOfEmployees}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Language</label>
                            <Select
                              className="select"
                              options={languageOptions}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "language")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-0">
                            <label className="col-form-label">Description</label>
                            <textarea
                              className="form-control"
                              rows={5}
                              name="description"
                              value={newLead.description}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Basic Info */}

                {/* Address Info */}
                <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#address"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-map-pin-cog fs-20" />
                      </span>
                      Address Info
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse"
                    id="address"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Street Address
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="street"
                              value={newLead.street}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">City</label>
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              value={newLead.city}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              State / Province
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="state"
                              value={newLead.state}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3 mb-md-0">
                            <label className="col-form-label">Country</label>
                            <Select
                              className="select"
                              options={countryoptions1}
                              name="country"
                              value={countryoptions1.find(option => option.value === newLead.country) || null}
                              onChange={(selectedOption) => {
                                if (selectedOption) {
                                  setNewLead(prevState => ({
                                    ...prevState,
                                    country: selectedOption.value,
                                  }));
                                }
                              }}
                            />

                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="col-form-label">Zipcode</label>
                            <input
                              type="text"
                              className="form-control"
                              name="zip"
                              value={newLead.zip}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Address Info */}

                {/* Social Profile */}
                <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#social"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-social fs-20" />
                      </span>
                      Social Profile
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse"
                    id="social"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Facebook</label>
                            <input
                              type="text"
                              className="form-control"
                              name="facebook"
                              value={newLead.facebook}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Skype</label>
                            <input
                              type="text"
                              className="form-control"
                              name="skype"
                              value={newLead.skype}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Linkedin</label>
                            <input
                              type="text"
                              className="form-control"
                              name="linkedin"
                              value={newLead.linkedin}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Twitter</label>
                            <input
                              type="text"
                              className="form-control"
                              name="twitter"
                              value={newLead.twitter}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3 mb-md-0">
                            <label className="col-form-label">Whatsapp</label>
                            <input
                              type="text"
                              className="form-control"
                              name="whatsapp"
                              value={newLead.whatsapp}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="col-form-label">Instagram</label>
                            <input
                              type="text"
                              className="form-control"
                              name="instagram"
                              value={newLead.instagram}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Social Profile */}

                {/* Access */}
                <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#access-info"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-accessible fs-20" />
                      </span>
                      Access
                    </Link>
                  </div>
                  <div className="accordion-collapse collapse" id="access-info" data-bs-parent="#main_accordion">
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Visibility</label>
                            <div className="d-flex flex-wrap">

                              {/* Public */}
                              <div className="me-2">
                                <input
                                  type="radio"
                                  className="status-radio"
                                  id="public"
                                  name="visibility"
                                  value="public"
                                  checked={visibility === "public"}
                                  onChange={() => {
                                    setVisibility("public");
                                    setNewLead(prev => ({ ...prev, public: true, selectedPeople: [] }));
                                  }}
                                />
                                <label htmlFor="public">Public</label>
                              </div>

                              {/* Private */}
                              <div className="me-2">
                                <input
                                  type="radio"
                                  className="status-radio"
                                  id="private"
                                  name="visibility"
                                  value="private"
                                  checked={visibility === "private"}
                                  onChange={() => {
                                    setVisibility("private");
                                    setNewLead(prev => ({ ...prev, public: false, selectedPeople: [] }));
                                  }}
                                />
                                <label htmlFor="private">Private</label>
                              </div>

                              {/* Select user */}
                              <div data-bs-toggle="modal" data-bs-target="#access_view">
                                <input
                                  type="radio"
                                  className="status-radio"
                                  id="user"
                                  name="visibility"
                                  value="user"
                                  checked={visibility === "user"}
                                  onChange={() => {
                                    setVisibility("user");
                                    setTempSelectedUsers(newLead.selectedPeople);
                                    setNewLead(prev => ({ ...prev, public: false }));
                                  }}
                                />
                                <label htmlFor="user">Select user</label>
                              </div>

                            </div>
                          </div>

                          {/* Hiển thị user đã chọn */}
                          {visibility === "user" && newLead.selectedPeople.length > 0 && (
                            <div className="mt-2">
                              <strong>Selected Users:</strong>
                              <ul>
                                {newLead.selectedPeople.map(userId => {
                                  const user = users.find(u => u.id === userId);
                                  return user ? <li key={user.id}>{user.username}</li> : null;
                                })}
                              </ul>
                            </div>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Access */}

              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleCreateLead}
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </Offcanvas>
        <div className="modal fade" id="access_view" tabIndex={-1} aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Users</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    if (tempSelectedUsers.length === 0) {
                      setVisibility("public");
                      setNewLead(prev => ({ ...prev, public: true, selectedPeople: [] }));
                    }
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {users.map(user => (
                  <div key={user.id} className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`user-${user.id}`}
                      checked={tempSelectedUsers.includes(user.id)}
                      onChange={(e) => {
                        setTempSelectedUsers(prev =>
                          e.target.checked ? [...prev, user.id] : prev.filter(id => id !== user.id)
                        );
                      }}
                    />
                    <label className="form-check-label" htmlFor={`user-${user.id}`}>
                      {user.username}
                    </label>
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    if (tempSelectedUsers.length === 0) {
                      setVisibility("public");
                      setNewLead(prev => ({ ...prev, public: true, selectedPeople: [] }));
                    } else {
                      setNewLead(prev => ({ ...prev, selectedPeople: tempSelectedUsers }));
                    }
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal custom-modal fade" id="delete_deal" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0 m-0 justify-content-end">
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="success-message text-center">
                  <div className="success-popup-icon">
                    <i className="ti ti-trash-x" />
                  </div>
                  <h3>Remove Leads?</h3>
                  <p className="del-info">
                    Are you sure you want to remove lead you selected.
                  </p>
                  <div className="col-lg-12 text-center modal-btn">
                    <Link
                      to="#"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="/leads" className="btn btn-danger">
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Convert Lead Modal */}
        <Modal show={showConvertModal} onHide={() => handleCloseConvertModal()} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Convert Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3">
              <strong>Lead: </strong> {editingLead?.firstName} {editingLead?.lastName}
            </p>
            <Form>
              {/* Account Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Company</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    label="Create New Company"
                    name="accountType"
                    value="new"
                    checked={accountType === "new"}
                    onChange={() => {
                      setAccountType("new");
                      setAccountName(editingLead?.company || "");
                      setSelectedAccount(null);
                      setContactType("new");
                      setOpportunityType("new");
                      setSelectedSalutation(editingLead?.salutation || "");
                      setContactFirstName(editingLead?.firstName || "");
                      setContactLastName(editingLead?.lastName || "");
                      setOpportunityName(editingLead?.company || "");
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="Choose Existing Company"
                    name="accountType"
                    value="existing"
                    checked={accountType === "existing"}
                    onChange={() => {
                      setAccountType("existing");
                      setAccountName(editingLead?.company || "");
                      setSelectedAccount(null);
                    }}
                  />
                </div>

                {accountType === "new" && (
                  <Form.Control
                    className="mt-2"
                    type="text"
                    placeholder="Enter Company Name"
                    value={accountName}
                    onChange={(e) => setAccountName(e.target.value)}
                    required
                  />
                )}

                {accountType === "existing" && (
                  <Select
                    options={accountOptions}
                    isSearchable
                    value={selectedAccount}
                    onChange={(option) => setSelectedAccount(option)}
                  />
                )}
              </Form.Group>

              {/* Contact Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Contact</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    label="Create New Contact"
                    name="contactType"
                    value="new"
                    checked={contactType === "new"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setContactType("new");
                      setSelectedSalutation(editingLead?.salutation || "");
                      setContactFirstName(editingLead?.firstName || "");
                      setContactLastName(editingLead?.lastName || "");
                      setSelectedContact(null);
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="Choose Existing Contact"
                    name="contactType"
                    value="existing"
                    checked={contactType === "existing"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setContactType("existing");
                      setContactFirstName("");
                      setContactLastName("");
                    }}
                  />
                </div>

                {contactType === "new" && (
                  <>
                    <Select
                      className="select2"
                      options={optionSalutation}
                      classNamePrefix="react-select"
                      value={optionSalutation.find(option => option.value === selectedSalutation) || null}
                      onChange={(selectedOption) => setSelectedSalutation(selectedOption?.value || null)}
                    />
                    <Form.Control
                      className="mt-2"
                      type="text"
                      placeholder="First Name"
                      value={contactFirstName}
                      onChange={(e) => setContactFirstName(e.target.value)}
                      required
                    />
                    <Form.Control
                      className="mt-2"
                      type="text"
                      placeholder="Last Name"
                      value={contactLastName}
                      onChange={(e) => setContactLastName(e.target.value)}
                      required
                    />
                  </>
                )}

                {contactType === "existing" && (
                  <Select
                    options={contactOptions}
                    isSearchable
                    value={selectedContact}
                    onChange={(option) => setSelectedContact(option)}
                  />
                )}
              </Form.Group>

              {/* Opportunity Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Opportunity</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    label="Create New Opportunity"
                    name="opportunityType"
                    value="new"
                    checked={opportunityType === "new"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setOpportunityType("new");
                      setOpportunityName(editingLead?.company || "");
                      setSelectedOpportunity(null);
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="Choose Existing Opportunity"
                    name="opportunityType"
                    value="existing"
                    checked={opportunityType === "existing"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setOpportunityType("existing");
                      setOpportunityName(editingLead?.company || "");
                    }}
                  />
                </div>

                {opportunityType === "new" && (
                  <Form.Control
                    className="mt-2"
                    type="text"
                    placeholder="Enter Opportunity Name"
                    value={opportunityName}
                    onChange={(e) => setOpportunityName(e.target.value)}
                    required
                  />
                )}

                {opportunityType === "existing" && (
                  <Select
                    options={opportunityOptions}
                    isSearchable
                    value={selectedOpportunity}
                    onChange={(option) => setSelectedOpportunity(option)}
                  />
                )}
              </Form.Group>

              {/* Converted Status */}
              <Form.Group className="mb-3">
                <Form.Label>Converted Status</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  value={
                    statusOptions.find((status) => status.id === maxorder)?.name ||
                    "No Status"
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConvertLead}>Convert</Button>
          </Modal.Footer>
        </Modal>
        <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
      </>
    </>
  );
};

export default LeadsKanban;
